<template>
  <section class="order-detail">
    <ul class="order-detail-head">
      <li><span class="label">订单号：{{ orderDetail.order2No }}</span></li>
       <li><span class="label">外部订单号：{{ orderDetail.externalOrderNo }}</span></li>
      <li><span class="label">订单状态：{{ orderDetail.orderStatus }}</span></li>
      <li><span class="label">结算方式：{{ orderDetail.paymentMode }}</span></li>
    </ul>
    <div class="order-detail-info">
        <h4>订单信息</h4>
        <div class="content">
          <div class="panel">
          <p class="panel-title">
            <span>收货人信息</span>
          </p>
          <div>
            <p class="panel-name">
              <span>收货人：{{  orderDetail.recipient && orderDetail.recipient.recipientName }}</span>
            </p>
            <p class="panel-address">
              <span>收货地址：{{  orderDetail.recipient && orderDetail.recipient.encryptedAddress }}</span>
            </p>
            <p class="panel-phone">
              <span>电话：{{ orderDetail.recipient && orderDetail.recipient.encryptedMobile }}</span>
            </p>
          </div>
        </div>
        <div class="panel">
            <p class="panel-title">
              <span>物流信息</span>
            </p>
            <div>
              <p class="panel-logistic" v-for="(item, index) in orderTrack" :key="index">
                <span>物流公司：{{ item.logisticsCompany }} &nbsp;&nbsp; 物流单号：{{ item.logisticsNo }}</span>
                <span ><el-button type="text" @click="handleLogist(item)">查看物流</el-button></span>
                <!-- <span>查看物流</span> -->
              </p>
            </div>
          </div>
        </div>
    </div>
    <div class="time-line">
      <el-steps  align-center>
        <el-step :title="item.content" :description="item.time" v-for="(item, index) in orderDetail.eventChain || []" :key="index"></el-step>
      </el-steps>
    </div>
    <div class="table">
      <ul class="tableTit">
        <li style="width:33.3333%">商品</li>
        <li style="width:33.3333%">商品金额</li>
        <li style="width:33.3333%">商品状态</li>
      </ul>
      <div class="table-contet" v-if="orderList.length">
        <ul class="tableCon" v-for="(item, index) in orderList" :key="index">
          <li style="width:33.3333%">
            <p class="tableCon-top">
              <span>商品编号：</span>
              <span>{{ item.order3No }}</span>
            </p>
            <div class="tableCon-bottom">
                <p>
                  <el-image
                  style="width: 60px; height: 60px"
                  :src="item.pictureUrls[0]"
                  :preview-src-list="item.pictureUrls">
                </el-image>
                </p>
                <p>
                  <span>{{ item.description.split('-')[0] }}</span>
                  <span>款号：{{ item.modelNo }}</span>
                  <span>{{ item.size }} {{ item.color }}</span>
                </p>
            </div>
          </li>
          <li style="width:33.3333%">¥ {{ (item.realPay && item.realPay/100).toFixed(2)}}</li>
          <li style="width:33.3333%">{{ item.productStatus }}</li>
        </ul>
      </div>
      <div
        v-else
        class="tableCon"
        style="justify-content:center;"
      >暂无数据
      </div>
    </div>

      <el-pagination
        v-if="pagination.total"
        background
        layout="prev, pager, next"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :current-page="pagination.pageNum"
        @current-change="setPageNum"
      >
      </el-pagination>
    <el-dialog title="" :visible.sync="dialogTableVisible">
      <div slot="title" class="dialog-title">
        <p>
          <span>物流公司：{{ currentTrack.logisticsCompany }}</span>
          <span>物流单号：{{ currentTrack.logisticsNo }}</span>
        </p>
      </div>
      <div class="block">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in currentTrack.traceItemList"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size"
            :timestamp="activity.time">
            {{activity.content}}
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
  </section>
</template>
<script>
// import url from './default.png'
import { mapGetters } from 'vuex'
import { MessageBox } from 'element-ui'
export default {
  name: 'sallDetail',
  data () {
    return {
      dialogTableVisible: false,
      orderDetail: {},
      orderTrack: [],
      currentTrack: [],
      orderList: [],
      pagination: {
        pageNum: 1,
        pageSize: 5,
        total: 0
      },
      externalOrderNo:''
    }
  },
  computed: {
    ...mapGetters({
      userinfo: 'prevStore/userinfo'
    })
  },
  methods: {
    handleAddress: function () {
      MessageBox.alert('这是一段内容', '', {
        showConfirmButton: false,
        customClass: 'order-deatail-info'
      })
    },
    handleLogist: function (item) {
      this.dialogTableVisible = true
      this.currentTrack = item
    },
    getOrderDetail () {
      const { orderNo } = this.$route.query
      this.$http.getOrderDetail({ orderId: orderNo }).then(({ code, data, message }) => {
        if (code === 200) {
          this.orderDetail = data
          if (data.deliveryNos && data.deliveryNos.length !== 0) {
            this.getTrack(data.deliveryNos.join(','))
          }
          this.getTableData(orderNo)
        } else {
          this.$message.error(message || '订单数据获取失败')
        }
      })
    },
    getTrack (deliveryOrderId) {
      this.$http.getTrack({ deliveryOrderId }).then(({ code, data, message }) => {
        if (code === 200) {
          this.orderTrack = data
        } else {
          this.$message.error(message || '订单数据获取失败')
        }
      })
    },
    getTableData (orderId) {
      this.$http.getTableData({ orderId, ...this.pagination }).then(({ code, data, message }) => {
        if (code === 200) {
          const { result, pageIndex: pageNum, pageSize, total } = data
          this.orderList = result || []
          this.pagination = { ...this.pagination, pageNum, pageSize, total }
        } else {
          this.$message.error(message || '订单数据获取失败')
        }
      })
    },
    setPageNum (page) {
      this.pagination.pageNum = page
      const { orderNo } = this.$route.query
      this.getTableData(orderNo)
    }
  },

  created () {
    this.$store.commit('prevStore/setnavindex', 3);
    this.externalOrderNo = this.$route.query.externalOrderNo;
  },
  mounted () {
    this.getOrderDetail()
  },
  components: {
  }
}
</script>
<style lang="scss">
  .order-detail{
    width: 1180px;
    margin: 0 auto;
    position: relative;
    margin-top:40px;
    margin-bottom: 40px;
    .order-detail-head{
      display: flex;
      justify-content: space-between;
      width: 100%;
      border: 1px solid #eaeefb;
      line-height: 40px;
      padding: 10px;
      .label{
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        font-size: 14px;
      }
    }
    .order-detail-info{
        display: flex;
        flex-direction: column;
        font-size: 16px;
        text-align: left;
        h4{
          margin: 18px 0;
          padding-left: 30px;
        }
        .content{
          display:flex;
          .panel{
            // display: flex;
            flex: 1;
            border: 1px solid #eaeefb;
            padding: 20px 20px 20px 60px;
            text-align: left;
            p{
              margin-top: 10px;
              span{
                padding-left: 8px;
              }
            }
            .panel-title{
              span{
                position: relative;
                // padding-left: 8px;
                &::before{
                  content: '';
                  position: absolute;
                  left: 0;
                  width: 3px;
                  height:20px;
                  background-color: #ff4b55;
                }
              }
            }
          }
        }
    }
    .time-line{
      margin-top: 30px;
      .el-step{
        .el-step__head{
          .el-step__line{
            background-color:#e4e7ed;
          }
          .el-step__icon{
            width: 12px;
            height: 12px;
            background-color:#e4e7ed;
            border:none;
            top:4px;
            div{
              display: none;
            }
          }
        }
        .el-step__main{
          .el-step__title,.el-step__description{
            color: #2c3e50;
          }
        }
      }
    }
    .table {
      // margin: 60px 0 90px;
    .tableTit {
      display: flex;
      align-items: center;
      height: 54px;
      margin-bottom: 10px;
      background: rgba(248, 248, 248, 1);
      border-radius: 4px 4px 0px 0px;
      font-size: 14px;
      font-family: PingFangSC-Medium;
      font-weight: 800;
      color: rgba(0, 0, 0, 0.85);
      border-bottom: 2px solid rgba(232, 232, 232, 1);
    }
    .table-contet{
      .tableCon {
        display: flex;
        align-items: center;
        height: 100px;
        padding: 10px 0;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
        text-align: center;
        box-sizing: content-box;
        li{
          &:first-child{
            .tableCon-top{
              display: flex;
              margin-left: 20%;
            }
            img {
              width: 60px;
            }
            .tableCon-bottom{
              display: flex;
               margin-left: 20%;
               p:nth-child(2){
                 margin-left:10px;
                 text-align: left;
                 display: flex;
                 flex-direction: column;
               }
            }
          }
        }
      }

    }
    .tableCount {
      display: flex;
      justify-content: flex-end;
      padding: 15px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(238, 47, 121, 1);
    }
  }
  .el-dialog__wrapper{
    .el-dialog{
      .dialog-title{
          text-align: left;
        p{
         display: flex;
         justify-content:space-between;
        }
      }
      .el-dialog__header{
        padding-top: 30px;
        padding-right: 48px;
        .el-dialog__headerbtn{
          top: 10px;
          right: 12px;
          font-size: 20px;
        }
      }
    }
    .el-timeline{
      padding-left: 35px;
      .el-timeline-item{
        text-align: left;
        .el-timeline-item__node--primary{
          background-color: #ff4b55;
        }
      }
    }
  }
}
.order-deatail-info{
  .el-message-box__header{
    .el-message-box__headerbtn{
      .el-message-box__close{
        font-size: 20px !important;
      }
    }
  }
}
</style>
